module.exports = __webpack_public_path__ + "static/media/min-BBB.eaacb60f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/min-BBB.jpg
// module id = 1096
// module chunks = 0